var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7759 1C13.1559 1 13.4425 1.33333 13.2892 1.95333L12.0496 7.81833L10.6659 8.17334L8.85762 10.0623L5.96588 7.92667C5.94868 7.91432 5.93466 7.89806 5.92499 7.87922C5.91532 7.86038 5.91028 7.83951 5.91028 7.81833C5.91028 7.79716 5.91532 7.77629 5.92499 7.75745C5.93466 7.73861 5.94868 7.72234 5.96588 7.71L10.5 4C10.7333 3.79333 10.45 3.69333 10.1433 3.88L4.30255 7.02C4.28305 7.03272 4.26091 7.04083 4.23781 7.04372C4.2147 7.0466 4.19125 7.04419 4.16922 7.03667L1.43922 6.17333C0.832549 5.99667 0.832549 5.58 1.57588 5.28333L12.4992 1.07C12.5858 1.02844 12.6799 1.00464 12.7759 1Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15ZM10.585 13.1H11.7598V8.8168H10.7168L9.24609 10.015L9.84668 10.7533L10.333 10.352C10.4404 10.2562 10.5303 10.1645 10.6025 10.0766C10.5908 10.3051 10.585 10.557 10.585 10.8324V13.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.f3ac0fb87d7d99cbb38e4fe4ae4fc191.svg";
export { ForwardRef as ReactComponent };